import { MenuFoldOutlined, MenuUnfoldOutlined, UploadOutlined, UserOutlined, VideoCameraOutlined } from '@ant-design/icons'
import { Button, Layout, Menu, theme } from 'antd'
import Sider from 'antd/es/layout/Sider';
import React, { useEffect, useState } from 'react'
import styled from 'styled-components';
import Header from '../header/Header';
import logo from "../../assets/finallogo.png";
import { useLocation, useNavigate } from 'react-router-dom';

const CustomSiderComponent = styled(Sider)`
  display: block;
  background: black;
  @media (max-width: 768px) {
    display: none;
  }
`;

const CustomButton = styled(Button)`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

const CustomSiderBackground = styled.div`
  background-color: black;
  height: 100vh;
`;

const CustomSider = ({ children }) => {
    const [menuSelected, setMenuSelected] = useState('1')
    const [collapsed, setCollapsed] = useState(true);
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    const nav = useNavigate();

    const location = useLocation();

    useEffect(() => {
        if (location.pathname == "/") {
            setMenuSelected('1');
        } else if (location.pathname == "/profile") {
            setMenuSelected('2');
        } else if (location.pathname == "/search") {
            setMenuSelected('3');
        } else {
            setMenuSelected('1');
        }
    }, [location])


    return (
        <Layout>
            <CustomSiderComponent style={{ background: "black" }} trigger={null} collapsible collapsed={collapsed}>
                <CustomSiderBackground>
                    <div className="demo-logo-vertical">
                        <img src={logo} alt="Logo" style={{ width: '100%', padding: '16px' }} />
                    </div>
                    <Menu
                        selectedKeys={[menuSelected]}
                        theme="dark"
                        mode="inline"
                        style={{ background: "black" }}
                        items={[
                            {
                                key: '1',
                                icon: <VideoCameraOutlined />,
                                label: 'home',
                                onClick: () => nav("/")
                            },

                            {
                                key: '2',
                                icon: <UserOutlined />,
                                label: 'profile',
                                onClick: () => nav("/profile")
                            },
                        ]}
                    />
                </CustomSiderBackground>
            </CustomSiderComponent>
            <Layout style={{ background: "black" }}>
                <CustomButton
                    type="text"
                    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                    onClick={() => setCollapsed(!collapsed)}
                    style={{
                        fontSize: '16px',
                        color: "white",
                        width: 64,
                        height: 64,
                        zIndex: 9999,
                    }}
                />
                <Header />
                {children}
            </Layout>
        </Layout>
    )
}

export default CustomSider